import { api } from 'services/companiesApi';

export const postGenerateReport = async (
	startDate: string,
	endDate: string,
) => {
	return await api.post('/sires/generate-txt', {
		startDate,
		endDate,
	});
};
